Share = LP.module('Share')

ShareActions =

  selectShareMethod: (context, method) ->
    context.dispatch 'share:selection', method

Share.ShareActions = ShareActions
